import CaseStatusComparison from './CaseStatusComparison';

export default CaseStatusComparison;
